import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosError,
} from 'axios';

import store from '@/store/index';

const restClient: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000,
});

const switchData = (): boolean => process.env.VUE_APP_API_URL === 'http:\/\/localhost:3001';

const generateUrl = (endpoint: string, impersonateEmail: string | null): string => {
  if (!impersonateEmail) {
    return endpoint;
  } else {
    const queryChar = endpoint.indexOf('?') > -1 ? '&' : '?';
    return endpoint + queryChar + '_switch_user=' + impersonateEmail;
  }
};

const request = (
  method: string,
  endpoint: string,
  payload?: any,
  headers?: any,
): Promise<AxiosResponse> => {
  store.commit('setGlobalLoading', true);

  const token = localStorage.getItem('token');
  const impersonate = localStorage.getItem('impersonate');

  return new Promise((resolve, reject) => {
    restClient({
        method: method.toUpperCase(),
        url: generateUrl(endpoint, impersonate),
        data: payload ? payload : undefined,
        headers: {
          Authorization: token ? 'Bearer ' + token : undefined,
          ...headers || undefined,
        },
      } as any)
      .then((response: AxiosResponse) => resolve(switchData() ? response : response.data))
      .catch((error: AxiosError) => {
        reject(error!.response!.data);
      })
      .finally(() => store.commit('setGlobalLoading', false));
  });
};

export {
  request,
};
